<template>
 <div class="fill-height">
   <div class="container mt-10 mb-10 align-items-center mobdiff">
    <div class="toplogo text-center">
             <div class="back-button">
                <v-btn to="/dashboard" color="primary" >
                    <span class="material-icons">keyboard_arrow_left</span> Dashboard
                 </v-btn>
             </div>
             <h1>Ask your question</h1>
        </div>     
     <div class="dashboard mt-10">
       <h2 class="text-center"></h2>
       <div class="question-area" v-show="first">
          <div class="column">
            <v-select  :items="categories" @change="getSubcat()" item-text="name" item-value="id" label="Choose Section" v-model="category" hide-details outlined></v-select>
          </div>
          <div class="errorclass" v-if="error.category">{{ error.category }}</div>
          <div class="column">
            <v-select  :items="subcategories" item-text="name" item-value="id" label="Choose Category" v-model="subcategory" hide-details outlined></v-select>
          </div>
          <div class="errorclass" v-if="error.subcategory">{{ error.subcategory }}</div>
               <div class="column">
            <div><span class="boldheading">Add Question Avatar :</span></div>
            <div class="mt-3 d-flex align-items-center">
              <v-avatar class="mr-5" size="50px"><img alt="Avatar" :src="image" ></v-avatar>
              <input type="file" ref="files" accept="image/*" @change="handleFilesUpload" />
            </div>
            <div class="red--text" v-if="avatarerror">{{ avatarerror }}</div>
          </div>
          <div class="column">
            <v-textarea label="Question" auto-grow rows="2" row-height="25" v-model="question" hide-details outlined></v-textarea>
          </div>
          <div class="errorclass" v-if="error.question">{{ error.question }}</div>  
          <div class="column optionaction">
            <div><span class="boldheading">Options:</span></div>
            <div class="optionsval">
                <div class="optname"><v-text-field  name="option" outlined  type="text" v-model="options[0]" hide-details/></div>
                <div class="optact">&nbsp;</div>
            </div>
            <div class="optionsval">
                <div class="optname"><v-text-field  name="option" outlined  type="text" v-model="options[1]" hide-details/></div>
                <div class="optact">&nbsp;</div>
            </div>
            <div class="optionsval" v-for="(input,k) in inputs" :key="k">
                <div class="optname"><v-text-field  name="option" outlined  type="text" v-model="options[k+2]" hide-details/></div>
                <div class="optact"><v-btn color="red" class="white--text" @click="removeField(k)">Delete</v-btn></div>
            </div>
            <div>
                <v-btn color="green" class="white--text"  @click="addField()">Add More option</v-btn>
            </div>
          </div>
          <div class="errorclass" v-if="error.options">{{ error.options }}</div>
          <div class="column text-right mt-5 bigbtn">
            <v-btn color="secondary" @click="next()">Next</v-btn>
          </div>
       </div> 
       <div class="action-area" v-show="second">
          <!-- Country and Timezone in single responsive row -->
          <div class="responsive-row">
            <div class="responsive-col">
              <div><span class="boldheading">Country</span></div>
              <div class="mt-3">
                <v-select :items="countries" item-text="name" label="Country" v-model="country" hide-details @change="getTimeZone()" solo></v-select>
              </div>
            </div>
            <div class="responsive-col">
              <div><span class="boldheading">Timezone</span></div>
              <div class="mt-3">
                <v-select :items="timezoneList" item-text="name" label="Timezone" v-model="timezone" hide-details solo></v-select>
              </div>
            </div>
          </div>
          
          <!-- Start and End Time in single responsive row -->
          <div class="responsive-row mt-4">
            <div class="responsive-col">
              <div><span class="boldheading">Start Time</span></div>
              <div class="time-inputs mt-3">
                <div class="date-input">
                  <date-pick class="dobpicker" :format="'DD/MM/YYYY'" v-model="startdate">
                    <template v-slot:default="{toggle}">
                      <v-text-field  
                        hide-details 
                        solo  
                        label="Start Date" 
                        @click="toggle" 
                        placeholder="DD/MM/YYYY" 
                        v-model="startdate">
                      </v-text-field>
                    </template>
                  </date-pick>
                </div> 
                <div class="time-input">
                  <vue-timepicker 
                    v-model="starttime" 
                    format="hh:mm A"
                    :disabled="!startdate"
                    placeholder="Select time">
                  </vue-timepicker>
                </div>
              </div>
              <div class="mt-2"><span class="italic">(If you want your question to become live immediately click the submit button.)</span></div>
              <div class="errorclass" v-if="error.startimeerror">{{ error.startimeerror }}</div>
            </div>

            <div class="responsive-col">
              <div><span class="boldheading">End Time</span></div>
              <div class="time-inputs mt-3">
                <div class="date-input">
                  <date-pick class="dobpicker" :format="'DD/MM/YYYY'" v-model="enddate">
                    <template v-slot:default="{toggle}">
                      <v-text-field  
                        hide-details 
                        solo  
                        label="End Date" 
                        @click="toggle" 
                        placeholder="DD/MM/YYYY" 
                        v-model="enddate">
                      </v-text-field>
                    </template>
                  </date-pick>
                </div> 
                <div class="time-input">
                  <vue-timepicker 
                    v-model="endtime" 
                    format="hh:mm A"
                    :disabled="!enddate"
                    placeholder="Select time">
                  </vue-timepicker>
                </div>
              </div>
              <div class="mt-2"><span class="italic">(Unless you show a end time and date your question will run 7 days.)</span></div>
             <div class="mt-3 d-flex align-items-center">
                <v-checkbox 
                  v-model="timeExtension" 
                  label="Request time extension from admin" 
                  hide-details
                  @change="onTimeExtensionChange">
                </v-checkbox>
                <v-icon 
                  class="help-icon ml-2" 
                  @click="showTimeExtensionDialog"
                  color="primary"
                  small>
                  help
                </v-icon>
              </div>
              
              <div class="errorclass" v-if="error.endtimeerror">{{ error.endtimeerror }}</div>
              <div class="errorclass" v-if="error.timeextensionerror">{{ error.timeextensionerror }}</div>
            </div>
          </div>
         
          <div class="column" v-if="!hidefornow">
            <div><span class="boldheading">Total Prize Pot</span></div> 
            <div class="innerdflex">
               <div class="inerhead">Kels</div>
               <div class="inerval">
                  <v-text-field  name="option" outlined  type="text" v-model="kels" hide-details/>
                  <div class="errorclass" v-if="error.kelserror">{{ error.kelserror }}</div>
                </div>
               <div class="inerhead">$</div>
               <div class="inerval">
                 <v-text-field  name="option" outlined  type="text" v-model="cents" hide-details/>
                 <div class="errorclass" v-if="error.centserror">{{ error.centserror }}</div>
              </div>
            </div> 
          </div>
          <div class="column" v-if="!hidefornow">
            <div><span class="boldheading">Answer Fee</span></div> 
            <div class="innerdflex">
               <div class="inerhead">Kels</div>
               <div class="inerval">
                 <v-text-field  name="option" outlined  type="text" v-model="anskels" hide-details/>
                 <div class="errorclass" v-if="error.anskelserror">{{ error.anskelserror }}</div>
               </div>
               <div class="inerhead">$</div>
               <div class="inerval">
                 <v-text-field  name="option" outlined  type="text" v-model="anscents" hide-details/>
                 <div class="errorclass" v-if="error.anscentserror">{{ error.anscentserror }}</div>
               </div>
            </div> 
          </div>

          <div class="column-flex mt-10">
            <div class="leftpart"><v-btn color="secondary" @click="prev()">Edit Question</v-btn></div>
            <div class="rightpart"><v-btn color="primary" @click="save()">Save</v-btn></div>
          </div>
       </div>
     </div>
   </div>
    <v-dialog v-model="timeExtensionDialog" max-width="400">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>Time Extension Request</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <div class="mt-3">
            Your request will be sent to admin. Once it's approved, your question will be published with the date you choose, regardless of the 7-day limit.
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="timeExtensionDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 
   <v-dialog transition="dialog-bottom-transition" max-width="300" v-model="dialog">
          <v-card>
            <v-toolbar color="primary" dark>Alert</v-toolbar>
            <v-card-text>
              <div class="mt-5 message">{{ message }}</div>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn text @click="closedialog()">Close</v-btn>
            </v-card-actions>
          </v-card>
    </v-dialog>
    <Loading :displayDialog="showdialog" />
 </div>   
</template>
<script>
  import Loading from '../components/Loader.vue';
  import DatePick from 'vue-date-pick';
  import VueTimepicker from 'vue2-timepicker';

  export default {
    name: 'Addquestion',
    components:{
      Loading,
      DatePick,
      VueTimepicker
    },
    data(){
      return{
        timezone:'',
        country:'Australia',
        countries:["America", "Australia", "United Kingdom","New Zeland"],
        timezoneList:[],
        categories:[],
        subcategories:[],
        category:'',
        subcategory:'',
        question:'',
        options: [],
        inputs:[],
        first:true,
        second:false,
        startdate:'',
        starttime:'',
        laststarttime:'',
        enddate:'',
        endtime:'',
        lastendtime:'',
        kels:0,
        cents:0,
        anskels:0,
        anscents:0,
        dialog:false,
        message:'',
        error:{'category':'','subcategory':'','question':'','options':'','startimeerror':'','endtimeerror':'','timeextensionerror':'' 
               /*'kelserror':'','centserror':'','anskelserror':'','anscentserror':''*/},
        starttimeerror:false,
        endtimeerror:false,
        starttimemsgerror:'',
        endtimemsgerror:'',
        showdialog:false,
        showdeposite:false,
        answerby:'vote',
        hidefornow:true,
        avatarerror:'',
        files:[],
        previewImage: null,
        timeExtension:false,
        timeExtensionDialog: false,
      }
    },
    created(){
      this.getCategories();
      this.getTimeZone();
    },  
    computed:{
       image () {
           // ✅ 1. Show preview if user has uploaded a file
      if (this.previewImage) {
        return this.previewImage
      }

      // ✅ 2. Else show avatar from Vuex (if available)
      if (this.$store.getters.getAvatar) {
        return this.$store.getters.getAvatar
      }

      // ✅ 3. Otherwise fallback to default
      return require('@/assets/avatar.png')
      }, 
    },  
    methods:{
      showTimeExtensionDialog() {
        this.timeExtensionDialog = true;
      },
      onTimeExtensionChange() {
        // Clear any previous time extension errors when checkbox state changes
        this.error.timeextensionerror = '';
        
        // If checkbox is checked and user unchecks it, also clear end date validation errors
        if (!this.timeExtension) {
          this.error.endtimeerror = '';
        }
      },
      handleFilesUpload()
      {
        const uploadedFile = this.$refs.files.files[0]
        if (!uploadedFile) return

        const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif']
        const fileExtension = uploadedFile.name.split('.').pop().toLowerCase()
        this.avatarerror = ''

        if (!allowedExtensions.includes(fileExtension)) {
         this.avatarerror = 'Please upload only image files (jpg, jpeg, png, gif)'
         this.previewImage = null
         return
        }

      this.files = uploadedFile

      // ✅ Use browser object URL for instant preview
      this.previewImage = URL.createObjectURL(uploadedFile)
      },
      closedialog(){
        this.dialog = false;
        this.message = '';
        if(this.showdeposite)
        {
          this.$root.$refs.Master.opendeposit();
        }
      },
      getTimeZone(){
      
        this.$store.dispatch("getTimeZone",{country:this.country}).then((response) => {
          this.timezoneList = response.data;
          this.timezone = response.data[0];
        });
      },
      getNumber(){
        return this.options.length;
      },
      getSubcat(){
        this.$store.dispatch("getSubcategory",{category:this.category}).then((response) =>{
            this.subcategories = response.data;  
        });
      },
      save() {
   // Reset previous errors
        this.error = {
          'category': '', 'subcategory': '', 'question': '', 'options': '', 
          'startimeerror': '', 'endtimeerror': '', 'timeextensionerror': ''
        };
        this.starttimeerror = false;
        this.endtimeerror = false;

        // Initialize datetime variables
        this.laststarttime = '';
        this.lastendtime = '';

        // Date/Time validation and processing
        let hasStartDateTime = false;
        let hasEndDateTime = false;

        // Check if start date is selected
        if (this.startdate && this.startdate.trim() !== '') {
          // If start date is selected, start time is required
          if (!this.starttime || this.starttime === '' || Object.keys(this.starttime).length === 0) {
            this.error.startimeerror = 'Start time is required when start date is selected';
            this.starttimeerror = true;
            return;
          }
          
          // Concatenate start date and time
          const startDateFormatted = this.formatDateFromPicker(this.startdate);
          const startTimeFormatted = this.formatTimeFromPicker(this.starttime);
          
          // Check if formatting was successful
          if (startDateFormatted === 'Invalid Date' || startTimeFormatted === 'Invalid Time') {
            this.error.startimeerror = 'Invalid start date or time format';
            this.starttimeerror = true;
            return;
          }
          
          this.laststarttime = startDateFormatted + ' ' + startTimeFormatted;
          
          // Validate start datetime is not in the past
          const startDateTime = new Date(this.laststarttime);
          const currentDateTime = new Date();
          
          if (isNaN(startDateTime.getTime()) || startDateTime <= currentDateTime) {
            this.error.startimeerror = startDateTime <= currentDateTime ? 'Start date and time cannot be in the past' : 'Invalid start date and time';
            this.starttimeerror = true;
            return;
          }
          
          hasStartDateTime = true;
        } else if (this.starttime && this.starttime !== '' && Object.keys(this.starttime).length > 0) {
          // If only start time is selected without date
          this.error.startimeerror = 'Start date is required when start time is selected';
          this.starttimeerror = true;
          return;
        }

        // Check if end date is selected
        if (this.enddate && this.enddate.trim() !== '') {
          // If end date is selected, end time is required
          if (!this.endtime || this.endtime === '' || Object.keys(this.endtime).length === 0) {
            this.error.endtimeerror = 'End time is required when end date is selected';
            this.endtimeerror = true;
            return;
          }
          
          // Concatenate end date and time
          const endDateFormatted = this.formatDateFromPicker(this.enddate);
          const endTimeFormatted = this.formatTimeFromPicker(this.endtime);
          
          // Check if formatting was successful
          if (endDateFormatted === 'Invalid Date' || endTimeFormatted === 'Invalid Time') {
            this.error.endtimeerror = 'Invalid end date or time format';
            this.endtimeerror = true;
            return;
          }
          
          this.lastendtime = endDateFormatted + ' ' + endTimeFormatted;
          
          // Validate end datetime is not in the past
          const endDateTime = new Date(this.lastendtime);
          const currentDateTime = new Date();
          
          if (isNaN(endDateTime.getTime()) || endDateTime <= currentDateTime) {
            this.error.endtimeerror = endDateTime <= currentDateTime ? 'End date and time cannot be in the past' : 'Invalid end date and time';
            this.endtimeerror = true;
            return;
          }
          
          hasEndDateTime = true;
        } else if (this.endtime && this.endtime !== '' && Object.keys(this.endtime).length > 0) {
          // If only end time is selected without date
          this.error.endtimeerror = 'End date is required when end time is selected';
          this.endtimeerror = true;
          return;
        }

        // Time extension validation logic
        if (this.timeExtension) {
          // If time extension is checked, both start and end date/time are required
          if (!hasStartDateTime) {
            this.error.timeextensionerror = 'Start date and time are required when requesting time extension';
            return;
          }
          if (!hasEndDateTime) {
            this.error.timeextensionerror = 'End date and time are required when requesting time extension';
            return;
          }
          
          // Validate that end time is after start time
          if (hasStartDateTime && hasEndDateTime) {
            const startDateTime = new Date(this.laststarttime);
            const endDateTime = new Date(this.lastendtime);
            
            if (endDateTime <= startDateTime) {
              this.error.endtimeerror = 'End date and time must be after start date and time';
              this.endtimeerror = true;
              return;
            }
          }
          
          // When time extension is checked, skip the 7-day validation
        } else {
          // Original 7-day validation logic when time extension is NOT checked
          if (hasStartDateTime && hasEndDateTime) {
            const startDateTime = new Date(this.laststarttime);
            const endDateTime = new Date(this.lastendtime);
            
            // Check if end time is after start time
            if (endDateTime <= startDateTime) {
              this.error.endtimeerror = 'End date and time must be after start date and time';
              this.endtimeerror = true;
              return;
            }
            
            // Check if the gap is within 7 days (only when time extension is not checked)
            if (!this.areDatesWithinSevenDays(this.laststarttime, this.lastendtime)) {
              this.error.endtimeerror = 'End date must be within 7 days from start date';
              this.endtimeerror = true;
              return;
            }
          }
        }

        // If only start date/time is provided and time extension is not checked, set default end time to 7 days later
        if (hasStartDateTime && !hasEndDateTime && !this.timeExtension) {
          const startDateTime = new Date(this.laststarttime);
          const defaultEndDateTime = new Date(startDateTime.getTime() + (7 * 24 * 60 * 60 * 1000)); // Add 7 days
          
          const year = defaultEndDateTime.getFullYear();
          const month = ('0' + (defaultEndDateTime.getMonth() + 1)).slice(-2);
          const day = ('0' + defaultEndDateTime.getDate()).slice(-2);
          const hours = ('0' + defaultEndDateTime.getHours()).slice(-2);
          const minutes = ('0' + defaultEndDateTime.getMinutes()).slice(-2);
          const seconds = ('0' + defaultEndDateTime.getSeconds()).slice(-2);
          
          this.lastendtime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
        }

        // Check if no errors occurred during validation
        if (!this.endtimeerror && !this.starttimeerror && !this.error.timeextensionerror) {
          this.showdialog = true;
          
          // Prepare timezone data - get timezone name from selected timezone object
          const selectedTimezone = this.timezone && typeof this.timezone === 'object' ? this.timezone.name : this.timezone;
          
          let formData = new FormData();
          let file = this.files;
             
          if(file != '')  
          {
            formData.append('avatar', file);
          }  
          formData.append("category", this.category);
          formData.append("subcategory", this.subcategory);
          formData.append("question", this.question);
          formData.append("starttime", this.laststarttime || "");
          formData.append("endtime", this.lastendtime || "");
          formData.append("kels", this.kels);
          formData.append("cents", this.cents);
          formData.append("anskels", this.anskels);
          formData.append("anscents", this.anscents);
          formData.append("answerby", this.answerby);
          formData.append("country", this.country);
          formData.append("timezone", selectedTimezone);
          formData.append("timeExtension", this.timeExtension ? 1 : 0);
          formData.append("options", JSON.stringify(this.options));
          
          // Proceed with form submission
          this.$store.dispatch("submitQuestion", formData).then((response) => {
            this.showdialog = false;
            if (response.status) {
              this.message = response.message;
              this.dialog = true;
              this.showdeposite = false;
              this.$store.dispatch("retrieveBalance");
              setTimeout(() => this.$router.push({ name: "dashboard" }), 2000);
            }
          });
        }
},

// Helper method to format date from date picker (DD/MM/YYYY to YYYY-MM-DD)
formatDateFromPicker(dateString) {
  if (!dateString || dateString.trim() === '') return 'Invalid Date';
  
  // Handle if dateString is already a Date object
  if (dateString instanceof Date) {
    const year = dateString.getFullYear();
    const month = ('0' + (dateString.getMonth() + 1)).slice(-2);
    const day = ('0' + dateString.getDate()).slice(-2);
    return year + '-' + month + '-' + day;
  }
  
  // Handle string format DD/MM/YYYY
  const parts = dateString.split('/');
  if (parts.length === 3) {
    const day = parts[0].padStart(2, '0');
    const month = parts[1].padStart(2, '0');
    const year = parts[2];
    
    // Validate the date parts
    if (isNaN(day) || isNaN(month) || isNaN(year) || 
        day < 1 || day > 31 || month < 1 || month > 12 || year < 1900) {
      return 'Invalid Date';
    }
    
    return year + '-' + month + '-' + day;
  }
  
  return 'Invalid Date';
},

// Helper method to format time from time picker
formatTimeFromPicker(timeObj) {
  if (!timeObj) return 'Invalid Time';
  
  // If timeObj is empty object
  if (typeof timeObj === 'object' && Object.keys(timeObj).length === 0) {
    return 'Invalid Time';
  }
  
  // If timeObj is a string like "12:00 AM"
  if (typeof timeObj === 'string' && timeObj.trim() !== '') {
    // Convert 12-hour format to 24-hour format
    const timeStr = timeObj.trim();
    const parts = timeStr.split(' ');
    
    if (parts.length === 2) {
      const timePart = parts[0];
      const ampm = parts[1].toUpperCase();
      const timeParts = timePart.split(':');
      
      if (timeParts.length >= 2) {
        let hours = parseInt(timeParts[0]);
        const minutes = parseInt(timeParts[1]);
        
        if (isNaN(hours) || isNaN(minutes)) return 'Invalid Time';
        
        // Convert to 24-hour format
        if (ampm === 'PM' && hours !== 12) {
          hours += 12;
        } else if (ampm === 'AM' && hours === 12) {
          hours = 0;
        }
        
        const hoursStr = hours.toString().padStart(2, '0');
        const minutesStr = minutes.toString().padStart(2, '0');
        
        return hoursStr + ':' + minutesStr + ':00';
      }
    }
    
    // If already in HH:MM format
    if (timeStr.includes(':')) {
      const parts = timeStr.split(':');
      if (parts.length >= 2) {
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        
        if (!isNaN(hours) && !isNaN(minutes) && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
          return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':00';
        }
      }
    }
  }
  
  // If timeObj is an object with HH and mm properties (vue-timepicker format)
  if (typeof timeObj === 'object' && timeObj.HH !== undefined && timeObj.mm !== undefined) {
    const hours = parseInt(timeObj.HH);
    const minutes = parseInt(timeObj.mm);
    
    if (!isNaN(hours) && !isNaN(minutes) && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) {
      return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':00';
    }
  }
  
  return 'Invalid Time';
}, 
      next()
      {
        if(this.category > 0 && this.subcategory > 0 && this.question.length > 0 && this.options.length >= 2)
        {
          this.first = false;
          this.second = true;
        }
        else
        {
           if(this.category == 0)
             this.error.category = "Select one section atleast.";
           else
             this.error.category = '';

           if(this.subcategory == 0)
             this.error.subcategory = "Select one category atleast.";
           else
             this.error.subcategory = '';  

           if(this.question.length == 0)
             this.error.question = "Write something in question.";
           else
             this.error.question = '';
           
           if(this.options.length < 2)
             this.error.options = "Write atleast 2 options.";
           else
             this.error.options = '';
        }
      },
      prev(){
        this.error = {};
        this.first = true;
        this.second = false;
      },
      getCategories(){
        this.$store.dispatch("getcategories").then((response) => {
           this.categories = [{id:0,name:"Choose Category"}]; 
           if(response.data.length > 0)
           {
            for(var i = 0; i < response.data.length; i++)
             {
               this.categories.push({ id:response.data[i].id, name:response.data[i].name });
             }     
           }
        });
      },
      addField() {
        this.inputs.push({ value: "" });
      },
      removeField(index) {
        this.options.splice(index+2,1);
        this.inputs.splice(index, 1);
      },  
      getstarttime()
      {
        var dateObject = new Date(this.starttime);
        var year    = dateObject.getFullYear();
        var month   = ('0' + (dateObject.getMonth() + 1)).slice(-2); // Months are 0-based
        var day     = ('0' + dateObject.getDate()).slice(-2);
        var hours   = ('0' + dateObject.getHours()).slice(-2);
        var minutes = ('0' + dateObject.getMinutes()).slice(-2);
        var seconds = ('0' + dateObject.getSeconds()).slice(-2);
        var formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
          
        var givenDate   = new Date(formattedDate);  
        var currentDate = new Date();
        if (givenDate >= currentDate) 
        {
          if(this.lastendtime == '')
          {
            this.laststarttime = formattedDate;
            this.starttimeerror = false;
          }
          else
          {
              var givenDateAgain   = new Date(formattedDate);  
              var currentDateAgain = new Date(this.lastendtime);
              if(givenDateAgain < currentDateAgain) 
              {
                this.laststarttime = formattedDate;
                this.starttimeerror = false;
              } 
              else 
              {
                this.message = "You can publish question within 7 days";
                this.starttimeerror = this.message;
                this.dialog = true;
                this.starttimeerror = true;
              }
          }
        } 
        else 
        {
          this.message = "Do not choose older date and time";
          this.starttimemsgerror = this.message;
          this.dialog = true;
          this.starttimeerror = true;
        }
      },
      getendtime()
      {
        this.message = ''; 
        var dateObject = new Date(this.endtime);
        var year = dateObject.getFullYear();
        var month = ('0' + (dateObject.getMonth() + 1)).slice(-2); 
        var day = ('0' + dateObject.getDate()).slice(-2);
        var hours = ('0' + dateObject.getHours()).slice(-2);
        var minutes = ('0' + dateObject.getMinutes()).slice(-2);
        var seconds = ('0' + dateObject.getSeconds()).slice(-2);
        var formattedDate = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
          
        var givenDate   = new Date(formattedDate);  
        var currentDate = new Date();
        //above check if date is not less than today date 
        //below in if condition check start date is present and check not more than 7 days
        if(givenDate >= currentDate) 
        {
           if(this.laststarttime != '')
           {
              if(this.areDatesWithinSevenDays(this.laststarttime, givenDate)) 
              {
                this.lastendtime = formattedDate;
                this.endtimeerror = false;
              } 
              else 
              {
                this.message = "You can publish question within 7 days";
                this.endtimemsgerror = this.message;
                this.dialog = true;
                this.endtimeerror = true;
              }
           }
           else
           {
              var currentDateNew = new Date(); 
              if(this.areDatesWithinSevenDays(currentDateNew, formattedDate)) 
              {
                this.lastendtime = formattedDate;
                this.endtimeerror = false;
              } 
              else 
              {
                this.message = "You can publish question within 7 days";
                this.endtimemsgerror = this.message;
                this.dialog = true;
                this.endtimeerror = true;
              }
           } 
        } 
        else 
        {
           this.message = "Do not choose older date and time";
           this.dialog = true;
           this.endtimeerror = true;
           this.endtimemsgerror = this.message;
        }   
      },
      areDatesWithinSevenDays(dateString1, dateString2) 
      {
        // Convert date strings to Date objects
        var startDate = new Date(dateString1);
        var endDate = new Date(dateString2);
        // Calculate the absolute difference in milliseconds
        var timeDifference = Math.abs(endDate - startDate);
        // Calculate the number of milliseconds in 7 days
        var sevenDaysInMillis = 7 * 24 * 60 * 60 * 1000;
        // Check if the difference is within 7 days
        return timeDifference < sevenDaysInMillis;
      }
    }  
  }
</script>    
<style scoped>
.column{margin-top: 10px;}
.optionsval{margin-bottom: 10px; margin-top: 5px;}
.optionaction{width: 70%;}
.optionaction div.optname{flex:0 0 90%}
.optionaction div.optact{flex:0 0 10%; margin-left: 5px;}
.optionsval{display: flex; align-items: center;}
.small-text{font-size: 12px;}
.column-flex{display: flex;}
.column-flex > div{flex: 0 0 50%;}
.column-flex .rightpart{text-align: right;}
.column-flex .rightpart button{width: 150px;}
.bigbtn button{width: 150px;}
.italic{font-size: 11px; font-style: italic;}
.boldheading{font-weight: bold;}
.innerdflex{display: flex; margin-top: 10px; align-items: center; }
.innerdflex div.inerhead{flex: 0 0 8%;}
.innerdflex div.inerval{flex: 0 0 15%; margin-right: 15px;}
.message{color: black;}
.errorclass{color: red; font-size: 12px; margin-top: 3px;}
.errorclass.d-flex  div{margin-right: 10px;}
::v-deep(.extension-dialog .v-card__text){padding: 10px !important;}
/* New responsive classes */
.responsive-row {
  display: flex;
  gap: 15px;
  margin-top: 10px;
}

.responsive-col {
  flex: 1;
  min-width: 0; /* Prevents flex items from overflowing */
}

.time-inputs {
  display: flex;
  gap: 8px;
}

.date-input {
  flex: 1;
}

.time-input {
  flex: 1;
}

.time-input span {
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .responsive-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .time-inputs {
    flex-direction: column;
    gap: 10px;
  }
  
  .innerdflex div.inerhead{
    flex: 0 0 15%;
  }
  
  .innerdflex div.inerval{
    flex: 0 0 30%; 
    margin-right: 15px;
  }
  
  .back-button{
    top:-77%
  }
  
  .column-flex {
    flex-direction: column;
    gap: 10px;
  }
  
  .column-flex > div {
    flex: 1;
    text-align: center;
  }
  
  .column-flex .rightpart {
    text-align: center;
  }
  
  .bigbtn {
    text-align: center;
  }
  
  .optionaction {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .time-inputs {
    gap: 8px;
  }
  
  .responsive-row {
    gap: 15px;
  }
  
  .innerdflex {
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .innerdflex div.inerhead,
  .innerdflex div.inerval {
    flex: 0 0 45%;
    margin-right: 0;
  }
}

/* Keep original styles for compatibility */
.columntop {   
  display: flex;
}
.columntop .column { 
  flex: 0 0 49%;
}
.columntop .column:nth-child(2) { 
  margin-left: 10px; 
}
.makemetwo{
  display: flex;
}
.makemetwo div:nth-child(1){
  margin-right: 5px;
}
.timerpart span{
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)
}

@media screen and (max-width: 600px) {
  .column {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<style>
.time-input span > input{
  height: 48px !important;
}
</style>